import store from './store';
import router from "./routes";

export default function (url, options = {}) {
  if (undefined === options.headers || undefined === options?.headers['Accept']) {
    options.headers = undefined === options.headers ? {} : options.headers;

    options.headers['Accept'] = 'application/json';
  }

  if (undefined === options.headers || undefined === options?.headers['Content-type']) {
    options.headers = undefined === options.headers ? {} : options.headers;

    options.headers['Content-type'] = 'application/json';
  }

  const token = authenticationToken();

  if (token && undefined === options.headers || undefined === options?.headers['Authorization']) {
    options.headers = undefined === options.headers ? {} : options.headers;

    options.headers['Authorization'] = `Bearer ${token}`;
  }

  return fetch(url, options)
    .then(response => {
      if (response.status === 401) {
        return Promise.all([
          store.dispatch('user/setLoggedOut'),
          router.push('/login'),
          store.dispatch('notifications/setSuccess', 'Your session has expired. Please log in again. (Error: 2)'),
        ]).then(() => response);
      }

      return response;
    });
}

const authenticationToken = () => store.state.user.token;
